module.exports = __webpack_public_path__ + "4579e1339efbdb98edd60c70d4f5d59c.png";